import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import install_45global from "/vercel/path0/middleware/install.global.ts";
import persist_45query_45global from "/vercel/path0/middleware/persist-query.global.ts";
import referrer_45id_45global from "/vercel/path0/middleware/referrerId.global.ts";
import remove_45html_45ext_45global from "/vercel/path0/middleware/remove-html-ext.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  install_45global,
  persist_45query_45global,
  referrer_45id_45global,
  remove_45html_45ext_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}